import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.Moodboard = class Moodboard extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-moodboard';
    }

    constructor(element) {
        super(element);

        //MOODBOARD - FILTER METHOD
        var moodboardFilterBtn = $(".moodboard .filter-button");
        var moodboardFilterItem = $('.moodboard-filter-gallery .filter');
        var moodboardDropdown = $('.moodboard-tabs-dropdown');

        // Filter click event
        $(moodboardFilterBtn).click(function () {
            var moodboardFilterValue = $(this).attr('data-filter');

            $(moodboardFilterBtn).parent().removeClass('active');
            $(this).parent().addClass('active');

            if (moodboardFilterValue == "all") {
                $(moodboardFilterItem).show('1000');
            }
            else {
                $(moodboardFilterItem).not('.' + moodboardFilterValue).hide('3000');
                $(moodboardFilterItem).filter('.' + moodboardFilterValue).show('3000');

            }

            // For SMALLER SCREENS
            if ($(window).width() < 992) {
                $(moodboardDropdown).text($(this).text()).toggleClass('open');
                $(this).parent().parent().slideToggle();

                // Default active tab
                $(moodboardDropdown).each(function (i, elm) {
                    $(elm).text($(elm).next('ul').find('li.active span').text());
                });

            }
        });

        $(moodboardDropdown).on('click', function (e) {
            e.preventDefault();
            $(e.target).toggleClass('open').next('ul').slideToggle();
        });

        // Default active tab
        $(moodboardDropdown).each(function (i, elm) {
            $(elm).text($(elm).next('ul').find('li.active span').text());
        });

        // Show alt text
        var moodboardImage = $('.moodboard-filter-gallery .filter img');
        $(moodboardImage).each(function () {
            var altText = $(this).attr('alt');
            $('<div class="overlay-description">' + '<span>' + altText + '</span>' + '</div>').insertAfter(this);
        });
    }

    setVars() {
       
    }

    addEventListeners() {
    }


    render() {
        this.setVars();
        this.addEventListeners();
    }   

}

$(function () {
    new Snappy.Component.Moodboard();
});



// WEBPACK FOOTER //
// ./components/moodboard/scripts/moodboard.js